import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fragment from 'react-dot-fragment';
import { get, pick } from 'lodash';
import { history } from 'store.js';
import Metrics from 'services/metrics';
import { SocialActions, ConfigurationActions } from 'social-video-react-redux';
import { logoutSession } from 'containers/MusicPage/actions';
import { converter } from 'helpers/converter';
import SocialAvatarImage from 'components/forms/SocialAvatarImage';
import { writeObject, readObject } from 'utils/localStorageServices';
import { GetRegion } from 'constants.js';
import Utils from 'utils/Utils';
import { creditCardPayway } from 'components/user/MyAccountSelector';
import MenuSwitch from 'containers/Profiles/components/MenuSwitch';
import { getCounterValidEmail } from 'action-creators/ip_telmex';
import {
  getProfileMembers,
  getAdminUserId,
} from 'containers/Profiles/selectors';
import { UserContext } from 'providers/user.provider';
import './profileMenu.scss';

class ProfileMenu extends React.Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.dropdown = false;
    this.toogleOpen = this.toogleOpen.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  toogleOpen() {
    this.dropdown = !this.dropdown;
    this.forceUpdate();
  }

  toogleClose() {
    this.dropdown = !this.dropdown;
    this.forceUpdate();
  }

  openMenu() {
    if (!Utils.MobileCheck()) {
      this.dropdown = true;
      this.forceUpdate();
    }
  }

  handleChangeProfile = userHash => {
    this.context.changeProfile(
      userHash,
      this.props.members,
      this.props.adminUserId,
    );
  };

  waitToogleOpen() {
    setTimeout(() => {
      this.dropdown = false;
      this.forceUpdate();
    }, 200);
  }

  closeMenu() {
    this.dropdown = false;
    this.forceUpdate();
  }

  clearLocalStorage = e => {
    this.closeMenu();
    this.context.logout();
    localStorage.removeItem('epgVersion');
    localStorage.removeItem('epgMenu');
    localStorage.removeItem('epgLineUp');
    localStorage.removeItem('epgChannelGrid');
    localStorage.removeItem('isEmailRegister');
    localStorage.removeItem('getUserInfo');
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { translations, metadata, user, members } = nextProps;
    const userId = get(user, 'user_id', '');

    // Ugliest patch ever...
    // Cuando metadata no se ha cargado metadata tiene un objeto metadata pero cuando se carga desaparece y en su lugar tiene las metadatas
    const metadata2 = metadata.metadata || metadata;
    const translations2 = translations.translations || translations;
    // Si translations o metadata son un objeto vacio, no están cargados
    const isTranslationsLoaded = !(
      Object.keys(translations2).length === 0 &&
      translations2.constructor === Object
    );
    const isMetadataLoaded = !(
      Object.keys(metadata2).length === 0 && metadata2.constructor === Object
    );
    if (!isTranslationsLoaded || !isMetadataLoaded) {
      return;
    }
    if (!nextProps.socialApiConfig) {
      const gameId =
        metadata2.socialization_game_id || '585997d2c39004e67987c60d';
      const propsWithGameId = Object.assign({}, nextProps.config, { gameId });
      this.props.setApiConfiguration(propsWithGameId);
    }
  }

  componentDidMount() {
    const {
      translations,
      metadata,
      config,
      socialApiConfig,
      user,
      members,
    } = this.props;
    // Ugliest patch ever...
    // Cuando metadata no se ha cargado metadata tiene un objeto metadata pero cuando se carga desaparece y en su lugar tiene las metadatas
    const metadata2 = metadata.metadata || metadata;
    const translations2 = translations.translations || translations;

    // Si translations o metadata son un objeto vacio, no están cargados
    if (
      !metadata2 ||
      typeof metadata2 !== 'object' ||
      !translations2 ||
      typeof translations2 !== 'object'
    ) {
      return;
    }

    if (!socialApiConfig) {
      const gameId =
        metadata.socialization_game_id || '585997d2c39004e67987c60d';
      const propsWithGameId = Object.assign({}, config, { gameId });
      this.props.setApiConfiguration(propsWithGameId);
    }

    if (!this.props.loggedInProfile) {
      this.props.getLoggedInProfile(this.props.user.gamification_id);
    }
  }

  // esta es la funcion que redirige a la pantalla de social perfil (en menu de perfiles)
  beforeSocialProfile = e => {
    e.preventDefault();
    const socialProfile = `/${GetRegion()}/socialProfile`;

    const social_config = JSON.parse(
      get(this.props.metadata, 'social_config', '{}'),
    );
    const profiles_config = JSON.parse(
      get(this.props.metadata, 'profiles_config', '{}'),
    );
    const social = get(
      social_config,
      [GetRegion()],
      get(social_config, ['default'], {}),
    );
    const profiles = get(
      profiles_config,
      [GetRegion()],
      get(profiles_config, ['default'], {}),
    );

    const socialEnable = get(social, ['enable'], false);
    const profileEnable = get(profiles, ['enable'], false);

    let isAdmin = false;
    if (profileEnable && this.props?.profile?.admin) isAdmin = true;

    if (
      (socialEnable && !profileEnable) ||
      (socialEnable && profileEnable && isAdmin)
    ) {
      const userMailValidation = JSON.parse(
        this.props.metadata.user_mail_validation,
      );
      this.props
        .getCounterValidEmail(get(userMailValidation, 'mexico.limit'), () => {
          this.props.navigate(socialProfile,{ replace: true });
        })
        .then(wait => (!wait ? this.props.navigate(socialProfile, { replace: true }) : null));
    }
  };

  sendMetric = label => {
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Click',
      eventLabel: label,
    });
  };

  render() {
    let classDropdown = 'dropdown nav-logged-user-li';
    const suscription = `/${GetRegion()}/home/user?micuentafull#micuentavtc`;
    const payment = `/${GetRegion()}/home/user?micuentafull#micuentamodificarmediodepago`;
    const myProfile = `/${GetRegion()}/home/user?micuentafull#micuentamodifyuser`;
    const count = `/${GetRegion()}/home/user?micuentafull#micuentadevices`;
    const parental = `/${GetRegion()}/home/user?micuentafull#micuentacontrolpin`;
    const history = `/${GetRegion()}/home/user?micuentafull#micuentahistorial`;
    const preference = `/${GetRegion()}/home/preference?preference&amp;info=pref`;
    const styleRow = {
      float: 'left',
      width: '30px',
      height: '30px',
      paddingTop: '3px',
    };

    const profiles_config = JSON.parse(
      get(this.props.metadata, 'profiles_config', '{}'),
    );
    const profiles = get(
      profiles_config,
      [GetRegion()],
      get(profiles_config, ['default'], {}),
    );
    const profileEnable = get(profiles, ['enable'], false);

    if (this.dropdown !== false) {
      classDropdown = 'dropdown nav-logged-user-li open';
    }

    const showPaymentOption = this.props.hasCreditCardPayway;
    // Validar que haya info en localstorage
    // Si hay info en localstorage, continuar. Sólo la modal de levelUp sobreescribir el nivel del usuario en localstorage
    // Si no hay info en localstorage, setear info del nivel del usuario
    const localStorageUserLevelInfo = readObject('loginInfo.userLevelInfo');
    if (!localStorageUserLevelInfo && this.props.loggedInProfile) {
      const userLevelInfo = {};
      userLevelInfo.levelNumber = this.props.loggedInProfile.levelNumber;
      userLevelInfo.levelName = this.props.loggedInProfile.levelName;
      writeObject('loginInfo.userLevelInfo', userLevelInfo);
    }

    let fullName = '';
    if (profileEnable) {
      fullName = this.props?.profile?.username || '';
    } else {
      fullName = `${this.props.user.firstname} ${this.props.user.lastname}`;
    }

    if (!this.props.config || !this.props.metadata) {
      return null;
    }

    let showCompleteMenu = false;
    if (!profileEnable || (profileEnable && this.props?.profile?.admin)) {
      showCompleteMenu = true;
    }

    const userMenu = (
      <a
        className="dropdown-toggle dropdownUser menu_user"
      //  onClick={this.beforeSocialProfile}
      >
        <span className="nav_profileMenu--span">
          <SocialAvatarImage
            imageUrl={this.props?.profile?.user_image}
            facebookId={
              this.props.loggedInProfile && this.props.loggedInProfile.imageUrl
            }
            className="menu_user--img"
          />
        </span>
        {/* <span className="nav_profileMenu--span nav_profileMenu--padding">
          <div className="nav_profileMenu--div">
            {converter.convertUnicode(fullName)}
          </div>
        </span> */}
      </a>
    );

    return (
      <li
        className={classDropdown}
        onMouseEnter={this.openMenu}
        onMouseLeave={this.closeMenu}
      >
        <div
          className="dropdown-toggle dropdownUser menu_user custom-menu-user-style hidden-xs"
          data-toggle="toggle"
          aria-expanded="true"
        >
          {userMenu}
          {/* <div style={styleRow} onClick={this.toogleOpen}>
            <span className="caret" />
          </div> */}
        </div>
        <div
          className="dropdown-toggle dropdownUser menu_user visible-xs"
          onClick={this.toogleOpen}
          data-toggle="toggle"
          aria-expanded="true"
        >
          {userMenu}
          {/* <strong className="caret" /> */}
        </div>
        <ul
          className="dropdown-menu menu-user profile-menu"
          onMouseEnter={this.openMenu}
          onMouseLeave={this.closeMenu}
        >
          {profileEnable && (
            <MenuSwitch
              onSwitchProfile={this.handleChangeProfile}
              admin={this.props?.profile?.admin}
            />
          )}

          {showCompleteMenu && (
            <Fragment>
              <li className="">
                <a
                  href={suscription}
                  onClick={() => this.sendMetric('Suscripción')}
                >
                  {' '}
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'suscription',
                    'Suscripción',
                  )}{' '}
                </a>
              </li>
              {GetRegion() === 'mexico' && showPaymentOption && (
                <li className="">
                  <a
                    href={payment}
                    onClick={() => this.sendMetric('Medio de Pago')}
                  >
                    {converter.convertApaUnicode(
                      this.props.translations,
                      'payment_selection_lbl',
                      'Medio de Pago',
                    )}
                  </a>
                </li>
              )}
              <li className="">
                <a
                  href={myProfile}
                  onClick={() => this.sendMetric('Mi perfil')}
                >
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'my_profile',
                    'Mi perfil',
                  )}
                </a>
              </li>
              <li className="">
                <a
                  href={count}
                  onClick={() => this.sendMetric('Mis dispositivos')}
                >
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'my_devices',
                    'Mis dispositivos',
                  )}
                </a>
              </li>
              <li className="">
                <a
                  href={parental}
                  onClick={() => this.sendMetric('PIN de Protección')}
                >
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'access_code',
                    'Pin de Protección',
                  )}
                </a>
              </li>
              <li className="">
                <a href={history} onClick={() => this.sendMetric('Historial')}>
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'my_history',
                    'Historial',
                  )}
                </a>
              </li>
              <li>
                <a
                  href={preference}
                  onClick={() => this.sendMetric('Preferencias')}
                >
                  {converter.convertApaUnicode(
                    this.props.translations,
                    'preferences',
                    'Preferencias',
                  )}
                </a>
              </li>
            </Fragment>
          )}

          <li>
            <a onClick={this.clearLocalStorage}>
              {converter.convertApaUnicode(
                this.props.translations,
                'exit_btn_exit_txt',
                'Cerrar Sesión',
              )}
            </a>
          </li>
        </ul>
      </li>
    );
  }
}

function mapStateToProps(state) {
  return {
    checkLogin: state.checkLogin,
    translations: state.translations,
    user: state.user,
    config: state.config,
    metadata: state.metadata,
    loggedInProfile: state.social.loggedInProfile,
    socialApiConfig: state.apiConfiguration.config,
    hasCreditCardPayway: creditCardPayway(state),
    members: getProfileMembers(state),
    adminUserId: getAdminUserId(state),
  };
}

const mapDispatchToProps = dispatch => ({
  getLoggedInProfile(gamificationId) {
    dispatch(SocialActions.getLoggedInProfile(gamificationId));
  },
  setApiConfiguration(config) {
    dispatch(ConfigurationActions.setConfiguration(config));
  },
  getCounterValidEmail: (count, next) =>
    dispatch(getCounterValidEmail(count, next)),
  onMusicLogout: () => dispatch(logoutSession()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileMenu);
